export default {
  state: {
    settings: {
      timeBuffer: 0,
      markUpPercent: 0.1,
      arrivalBufferDomestic: 30,
      arrivalBufferInternational: 45,
      departureBufferDomestic: 90,
      departureBufferInternational: 150,
      nearByAirportMilesLimit: 50,
      groundLeg1Discount: 0,
      groundLeg2Discount: 0,
      groundLeg3Discount: 0,
      groundLeg4Discount: 0,
      groundLeg1: {
        free: false,
        value: 0,
        currency: '$'
      },
      groundLeg2: {
        free: false,
        value: 0,
        currency: '$'
      },
      groundLeg3: {
        free: false,
        value: 0,
        currency: '$'
      },
      groundLeg4: {
        free: false,
        value: 0,
        currency: '$'
      },
      requirePhone: 0,
      sessionTimeout: 900,
      sessionShowWarning: 180,
      forceGroundMiles: 100,
      customFlight: true
    }
  },
  mutations: {
    setSettingsData (state, data) {
      for (let field in data) {
        state.settings[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/settings.js